<template>
  <div>
    <a-modal
      v-model="visible"
      width="70%"
      centered
      :footer="null"
      :title="null"
      :closable="false"
      :maskClosable="false"
    >
      <div class="header">
        {{ lbl['modal_view_content_title'] }}
      </div>
      <div class="action">
        <div class="select">
          <a-select v-model="type" disabled class="w-100">
            <a-select-option
              v-for="e in pdpdOption"
              :key="e.value"
              :value="e.value"
            >
              {{ e.label }}
            </a-select-option>
          </a-select>
          <a-select
            v-model="version"
            @change="changeVersion"
            :disabled="versionList.length === 0"
            class="w-100"
          >
            <a-select-option
              v-for="(version, index) in versionList"
              :key="version.value"
            >
              <strong>
                {{ lbl['version_consent_text'] + ': ' + version.value }}
              </strong>
              <span v-if="index !== versionList.length - 1" class="update-date">
                {{ ' ' + dateFormat(version.update) }}
              </span>
            </a-select-option>
          </a-select>
        </div>
        <a-button
          class="btn-action"
          style="
            color: #636363;
            border-color: #c9c9c9;
            background-color: #ffffff;
          "
          @click="copyToClipboard(content)"
        >
          <a-icon type="copy" />
          <span>{{ lbl['copy_text_text'] }}</span>
        </a-button>
      </div>
      <div class="content">
        <a-tabs v-model="language" type="card" @change="changeLanguage">
          <a-tab-pane
            key="th"
            :tab="currentLocale == 'ph' ? lbl['ph-label'] : lbl['th-label']"
          >
          </a-tab-pane>
          <a-tab-pane key="en" :tab="lbl['eng-label']"> </a-tab-pane>
        </a-tabs>
        <a-skeleton v-if="onload" active />
        <a-empty v-if="!onload && !content" />
        <div v-if="!onload && content" v-html="content"></div>
      </div>

      <div class="action-btn">
        <button key="back" class="close-btn" @click="handleClose">
          {{ lbl['alert-box-success-close-button'] }}
        </button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import axios from 'axios'
import Account from '@/helper/AccountHelper.js'
import Locale from '@/helper/locale.js'
import Mixin from '@/mixin/Mixin'
import moment from 'moment'

export default {
  name: 'PdpaModal',
  mixins: [Mixin],
  data() {
    return {
      type: '',
      version: 1,
      content: '',
      pdpdOption: [],
      language: 'th',
      onload: false,
      PrimaryLanguageConsentUrl: null,
      SecondaryLanguageConsentUrl: null,
      currentLocale: Locale.getLocaleShort(),
      businessName: '',
    }
  },
  props: {
    visible: Boolean,
    data: Object,
    versionList: Array,
    history: Array,
  },
  mounted() {
    this.type = this.data.type
    this.version = this.data.DisplayVersion
    this.getConsentType()
    this.getContent()
  },
  created() {
    if (Account.getCacheProfileAddress().strBusinessName) {
      this.businessName = Account.getCacheProfileAddress().strBusinessName
    } else if (Account.getCacheUser().BusinessName) {
      this.businessName = Account.getCacheUser().BusinessName
    } else {
      this.businessName = ''
    }
  },
  methods: {
    getConsentType() {
      this.pdpdOption = [
        {
          label: this.lbl['term_and_condition_title'],
          value: 'TermAndCondition',
        },
        { label: this.lbl['privacy_policy_title'], value: 'PrivacyPolicy' },
        { label: this.lbl['marketing_title'], value: 'MarketingMessage' },
      ]
    },
    getContent() {
      this.onload = true
      return new Promise(resolve => {
        this.history.find(e => {
          if (e.DisplayVersion == this.version) {
            this.PrimaryLanguageConsentUrl = e.PrimaryLanguageConsentUrl
            this.SecondaryLanguageConsentUrl = e.SecondaryLanguageConsentUrl
          }
        })
        this.convertToText()

        resolve()
      })
    },
    convertToText() {
      var url =
        this.language == 'en'
          ? this.SecondaryLanguageConsentUrl
          : this.PrimaryLanguageConsentUrl
      axios
        .get(url)
        .then(response => {
          this.content = response.data
            ? response.data.replace(/{{business_name}}/g, this.businessName)
            : response.data
        })
        .catch(() => {
          this.content = null
        })
      this.onload = false
    },
    changeVersion() {
      this.getContent()
    },
    changeLanguage() {
      this.getContent()
    },
    copyToClipboard(content) {
      const el = document.createElement('textarea')
      el.value = content
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$message.success(this.lbl['copy_text_text'])
    },
    handleClose() {
      this.$emit('close')
    },
    dateFormat(date) {
      try {
        if (this.currentLocale == 'th') {
          const buddhistYear = moment.unix(date).year() + 543
          return moment.unix(date).locale('th').format(`DD MMM ${buddhistYear}`)
        } else {
          return moment.unix(date).format('DD MMM YYYY')
        }
      } catch {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #4a4a4a;
  padding: 16px;
  padding-top: 0;
  margin: 0 -16px;
  border-bottom: 1px solid #e3e3e3;
}
.action {
  margin: 16px auto;
  display: flex;
  gap: 46px;
  flex-flow: wrap;

  .select {
    display: flex;
    gap: 16px;
    flex: 8;
  }

  .btn-action {
    flex: 2;
    color: #636363;
  }
}
.content {
  height: 600px;
  overflow: auto;
  margin: 20px;
  color: #4a4a4a;
}
.close-btn {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  color: #636363;
  padding: 8px 16px;
  border-radius: 6px;

  &:hover {
    opacity: 0.8;
  }
}
</style>
